module.exports = __webpack_public_path__ + "img/3corazon.7278d51d.png";